import type { FC, MouseEvent } from 'react';
import React, { useEffect } from 'react';
import { InformationCircleLineSIcon } from '@alfalab/icons-glyph/InformationCircleLineSIcon';
import cn from 'classnames';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { useForm } from 'react-final-form';

import { Carousel } from '../../../carousel';

import type { ICashbackPackageOption, TCashbackPackages } from './models';

export const CashbackPackages: FC<TCashbackPackages> = ({
    Card,
    Text,
    Tooltip,
    card,
    carousel,
    config,
    getTooltipProps,
    hint,
    isPreselected = false,
    products,
    styles,
    title,
}) => {
    const formApi = useForm();

    useEffect(() => {
        return () => {
            formApi.change('cashbackPackage');
        };
    }, [formApi]);

    const tooltipProps = getTooltipProps({
        content: hint?.text,
        title: hint?.title,
    });

    return (
        <>
            <Text styler={config.titleOffset} tag="div">
                <Text tag="span" {...config.titleView}>
                    {title}
                </Text>
                {hint?.text && (
                    <Tooltip
                        contentClassName={
                            'customTooltip' in styles ? styles.customTooltip : undefined
                        }
                        fallbackPlacements={['bottom', 'top']}
                        position="top"
                        preventOverflow
                        targetClassName={cn(styles.target, styles.external)}
                        trigger="hover"
                        {...tooltipProps}
                    >
                        <InformationCircleLineSIcon
                            color="#6d7986"
                            height={config.titleIconSize}
                            width={config.titleIconSize}
                        />
                    </Tooltip>
                )}
            </Text>
            <Field<string>
                name="cashbackPackage"
                render={({ input }) => {
                    return (
                        <Carousel<ICashbackPackageOption>
                            containerClassName={cn(
                                styles.carouselContainer,
                                styles.external,
                                carousel?.containerClassName
                            )}
                            contentClassName={cn(
                                styles.carouselContent,
                                styles.external,
                                carousel?.contentClassName
                            )}
                            gridClassName={cn(styles.carouselGrid, styles.external)}
                            isCardUnselectable
                            isPreselected={isPreselected}
                            options={products}
                            renderCard={({ isSelected, onClick, option }) => (
                                <Card
                                    {...card}
                                    key={option.value}
                                    backgroundColor={option.backgroundColor}
                                    isSelected={isSelected}
                                    onClick={(e: MouseEvent) => {
                                        actions.onChange(input)(isSelected ? '' : option.value);
                                        onClick(e);
                                    }}
                                    subTitle={option.subTitle}
                                    title={option.title}
                                />
                            )}
                        />
                    );
                }}
            />
        </>
    );
};
